module.exports = __webpack_public_path__ + "img/resource-tech-image-14.ebe99d4f.jpg";